/** Phone: "Acht Uhr und schon zwölf Programme offen", the desktop stage scaled to fit, caption and way switch below. */
import { ld } from "@/lib/theme/light-dark";
import { useTranslations } from "next-intl";
import type { ReactNode } from "react";

import { ResponsiveScale } from "./hero-mobile-scale";
import { H, MOBILE_HERO_BAND_GUTTER, MOBILE_HERO_GUTTER } from "./hero-tokens";
import { ScrollStageCanvas, StageWaySwitch, useStageWay } from "./sections/scroll-stage";
import { StageCaption } from "./sections/scroll-stage-result";

export function HeroMobileStage(): ReactNode {
  const t = useTranslations("marketing.scrollStage");
  const { way, pick, switchRef } = useStageWay();
  return (
    <section aria-labelledby="scroll-stage-heading-mobile" style={{ position: "relative", margin: "60px auto 0" }}>
      <div style={{ textAlign: "center", margin: "0 auto", padding: `0 ${MOBILE_HERO_GUTTER}px` }}>
        <h2
          id="scroll-stage-heading-mobile"
          style={{
            fontFamily: H.display,
            fontWeight: 400,
            fontSize: 33,
            lineHeight: 1.12,
            letterSpacing: "-0.018em",
            textWrap: "balance",
            color: ld("#0B0F19", "#fafafa"),
            margin: 0,
          }}
        >
          {t("achtUhrProgrammeOffen")}
        </h2>
        <p style={{ fontSize: 16, lineHeight: 1.5, color: H.inkMute, margin: "14px auto 0" }}>
          {t("jederVorgangVerteiltMehrere")}
        </p>
      </div>

      {/* Center timing: windows stay while the short scaled stage is in view, resolve as it moves up. */}
      <div style={{ margin: "20px 0 0" }}>
        <ResponsiveScale baseWidth={1080} shadowPad={26} shadowPadX={MOBILE_HERO_BAND_GUTTER}>
          <ScrollStageCanvas
            timing={{ mode: "center", start: 0.8, end: -0.2 }}
            way={way}
            height={1092}
            headlineTop={540}
            resultTop={724}
            scale={1.92}
          />
        </ResponsiveScale>
      </div>

      <div style={{ marginTop: 6, padding: `0 ${MOBILE_HERO_GUTTER}px` }}>
        <StageCaption way={way} />
        <div style={{ marginTop: 16 }}>
          <StageWaySwitch way={way} pick={pick} switchRef={switchRef} />
        </div>
      </div>
    </section>
  );
}
